import React from 'react';
import { UI_ACCENT, type UiAccent } from './portalTheme';

export const PortalBadge: React.FC<{
  label: string;
  accent?: UiAccent;
  effect?: boolean;
  icon?: React.ReactNode;
  href?: string;
  className?: string;
}> = ({ label, accent = 'blue', effect = false, icon, href, className = '' }) => {
  const t = UI_ACCENT[accent];
  const shell = `inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[11px] font-semibold tracking-wide ${t.badge} ${
    effect ? t.badgeGlow : ''
  } ${className}`;

  if (href) {
    return (
      <a href={href} className={`${shell} hover:opacity-90 transition-opacity`}>
        {icon}
        {label}
      </a>
    );
  }
  return (
    <span className={shell}>
      {icon}
      {label}
    </span>
  );
};
